import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPaginationParams = (params) => ({
  type: actionTypes.SET_ADS_WITH_PROMOS_PAGINATION_PARAMS,
  payload: params
})
